/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    string, bool, func, node, object,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import mbpLogger from 'mbp-logger';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { MenuList } from '@material-ui/core';
import { flagOnQasFailed } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/AddressSearchQAS/AddressSearchQAS-Actions';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFeatureFlags } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

import QasClient from '../../../../../../../apis/qas-address-search-apis/qas-address-search-apis';
import { getOrderId } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { emitClickstreamCheckoutEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { getPageType } from '../Helpers/pageHelpers';

const styles = (theme) => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            minHeight: '2.2em',
        },
    },
    wrapSuggestion: {
        position: 'relative',
    },
    autoSuggestion: {
        position: 'absolute',
        backgroundColor: '#FFF',
        zIndex: 3000,
        width: '100%',
        padding: '0px 3px',
        maxHeight: '14rem',
        overflow: 'auto',
        [theme.breakpoints.down('sm')]: {
            '&::-webkit-scrollbar': {
                '-moz-appearance': 'none',
                '-webkit-appearance': 'none',
                background: '#C4C4C4',
                width: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '4px',
                backgroundColor: '#7B7B7B',
                boxShadow: '0 0 1px #7B7B7B',
            },
        },

    },
    addressList: {
        padding: '4px',
        fontWeight: '600',
        borderBottom: 'solid 1px #ecdede',
        fontSize: '0.9em',
    },
    menuListWrapper: {
        padding: '0px',
    },
});

const countryISOAlfa3Code = {
    US: 'USA',
    CA: 'CAN',
};

// const countryISOAlfa2Code = {
//     USA: 'US',
//     CAN: 'CA',
// };

const normalizeArrayToObject = (arr) => {
    const normalize = {};
    arr.forEach((item) => {
        normalize[[Object.keys(item)]] = item[[Object.keys(item)]];
    });
    return normalize;
};

const getGeoLocation = () => new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
        reject(new Error('noWindow'));
    } else if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
    } else {
        reject(new Error('noSupport'));
    }
});

class AddressVerificationSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            autoCompleteResult: {},
        };
        this.delayAutoComplete = null;
        this.location = {
            lat: '',
            long: '',
        };

        this.initGeoLocation = false;
    }

    componentDidUpdate(prevProps) {
        const {
            searchText, isFocus, countryCode, useGeoLocation,
        } = this.props;
        if (prevProps.searchText !== searchText && !isFocus) {
            this.searchAddress(searchText);
        }

        if (useGeoLocation && (prevProps.countryCode !== countryCode || !this.initGeoLocation)) {
            this.initGeoLocation = true;
            this.getUserLocation();
        }
    }

    getUserLocation = async () => {
        await getGeoLocation()
            .then((data) => {
                const { coords } = data;
                if (coords) {
                    const { latitude, longitude } = coords;
                    this.location = {
                        lat: `${latitude}`,
                        long: `${longitude}`,
                    };
                }
            }).catch((response) => {
                mbpLogger.logDebug({
                    appName: process.env.npm_package_name,
                    function: 'AddressVerificationSearch.js',
                    module: 'getGeoLocation - AddressVerificationSearch',
                    message: 'User has rejected get the geolocation',
                    jsError: response,
                });
                this.location = {
                    lat: '',
                    long: '',
                };
            });
    }

    handleKeyDown = (e, index) => {
        const { autoCompleteResult } = this.state;
        const { onBlurHandler } = this.props;
        if (e.key === 'Tab' && (index + 1) === autoCompleteResult.results.length) {
            onBlurHandler();
        }
    }

    getSuggestions = () => {
        const { autoCompleteResult } = this.state;
        const { classes } = this.props;
        if (autoCompleteResult
            && autoCompleteResult.results
            && autoCompleteResult.count
            && autoCompleteResult.count > 0) {
            return autoCompleteResult.results.map((address, index) => (
                <MenuItem
                    className={classes.addressList}
                    key={`suggestionAVS${address.suggestion.replace(/\s/g, '')}`}
                    onClick={() => { this.handlePickAnAddress(address); }}
                    onKeyDown={(e) => { this.handleKeyDown(e, index); }}
                    tabIndex={0}
                    classes={{ root: classes.root }}
                >
                    {address.suggestion}
                </MenuItem>
            ));
        }

        if (autoCompleteResult
            && autoCompleteResult.results
            && autoCompleteResult.count === 0) {
            return (
                <MenuItem
                    className={classes.addressList}
                    key="No_Match_Found"
                    onClick={() => { this.handleNoMatch(); }}
                >
                    No address match found
                </MenuItem>
            );
        }
        return null;
    }

    handleNoMatch = () => {
        const { onBlurHandler } = this.props;
        this.resetAutoSearch();
        onBlurHandler();
    }

    returnSelectedAddress = (formattedAddress) => {
        // This function is essential for populating address with QAS data
        const {
            callEmitClickstreamCheckoutEvent, cartId,
            getPreFillAddressDetails, searchText, searchId,
        } = this.props;
        const { autoCompleteResult } = this.state;
        const pageType = getPageType();

        const { components, address } = formattedAddress;
        const nComponents = normalizeArrayToObject(components);
        const nAddress = normalizeArrayToObject(address);

        let address1 = nAddress.addressLine1;
        let address2 = `${nAddress.addressLine2} ${nAddress.addressLine3}`.trim();

        // Validating if there is address line 2 suggested for the address with suite, apt, etc
        if (!address2) {
            const addressWithAddressLine2 = autoCompleteResult.results.filter((result) => {
                const addressList = result.suggestion.split(',')?.[0];
                return addressList.indexOf(address1) >= 0 && addressList.length > address1.length;
            });
            if (addressWithAddressLine2.length > 0) {
                address2 = ' ';
            }
        }

        if (['APO', 'FPO'].includes(nComponents.locality1)) {
            address1 = nComponents.street1;
            address2 = nComponents.deliveryService4;
        }
        const selectedAddress = {
            addressLine1: address1,
            addressLine2: address2?.length > 30 ? address2?.substring(0, 30) : address2,
            city: nAddress.locality,
            state: nAddress.province,
            country: nComponents.countryISO1,
            zipcode: nAddress.postalCode.split('-')[0],
        };

        callEmitClickstreamCheckoutEvent({
            action: 'Click',
            label: 'Suggestion drop down',
            eventType: 'clickstream.checkout-address',
            eventSubType: 'qas-dropdown-selection',
            page: { type: pageType },
            order: { cartId },
            recipients: [
                {
                    userAddress: {
                        address1: searchText,
                        address2: '',
                        city: nAddress.locality,
                        state: nAddress.province,
                        zipcode: nAddress.postalCode.split('-')[0],
                        country: nComponents.countryISO1,
                    },
                    qasAddress: {
                        address1: selectedAddress.addressLine1,
                        address2: selectedAddress.addressLine2,
                        city: selectedAddress.city,
                        state: selectedAddress.state,
                        country: selectedAddress.country,
                        zipcode: selectedAddress.zipCode,
                    },
                    addressSource: searchId,
                    qasSuggestionsCount: autoCompleteResult.count || 0,
                },
            ],
        });

        getPreFillAddressDetails(selectedAddress);
        return selectedAddress;
    }

    handlePickAnAddress = (address) => {
        const { onBlurHandler, track } = this.props;
        if (address && address.format) {
            const { format } = address;
            const formatParams = qs.parse(format.substring(format.indexOf('?') + 1));
            QasClient.qasGet({}, 'format', formatParams).then((res) => {
                this.returnSelectedAddress(res.data);
                this.resetAutoSearch();
                onBlurHandler();
                track({
                    eventCategory: 'Checkout',
                    eventAction: 'Selected Google Address Recommendation',
                    eventLabel: '',
                });
            }).catch(() => {
                this.resetAutoSearch();
                onBlurHandler();
            });
        }
    }

    resetAutoSearch = () => {
        this.setState({
            autoCompleteResult: {},
        });
    }

    showSuggestion = () => {
        const { searchTextFocus, isFocus } = this.props;
        if (searchTextFocus || isFocus) {
            return true;
        }
        return false;
    }

    handleQASAddressFailed = () => {
        const { callFlagOnQasFailed, searchId, track } = this.props;
        callFlagOnQasFailed();

        track({
            eventCategory: 'Checkout',
            eventAction: 'Address Verification Search',
            eventLabel: `QAS Failed - V1 - ${searchId}`,
        });

        setTimeout(() => {
            if (typeof document !== 'undefined' && document.getElementById(searchId)) {
                document.getElementById(searchId).focus();
            }
        }, 200);
    }

    searchAddress = (searchText) => {
        const { featureFlags, cartId } = this.props;
        const searchTimeout = featureFlags['qas-address-search-timeout-value'] || 5;
        const whichQASContext = featureFlags['which-qas-context']; // state, state and zipcode or zipcode only
        const timeoutInSecs = searchTimeout * 1000;
        let addressSearchText = searchText || '';
        if (searchText.length >= 3) {
            const {
                countryCode,
                useGeoLocation,
                state,
                zipCode,
            } = this.props;
            let isoCountryCode = countryCode;
            if (countryCode && countryCode.length !== 3) {
                isoCountryCode = countryISOAlfa3Code[countryCode];
            }

            if (isoCountryCode) {
                const searchZipCode = zipCode.split('-')[0];
                addressSearchText = addressSearchText.trim();

                if (whichQASContext === 'state') {
                    addressSearchText += `, ${state}`;
                } else if (whichQASContext === 'state-and-zipcode') {
                    // This has been added because business want see
                    // relevant addresses, if the zipcode is already
                    // populated on the form
                    addressSearchText += `, ${state} ${searchZipCode}`;
                } else if (whichQASContext === 'zipcode') {
                    addressSearchText += `, ${searchZipCode}`;
                }

                const params = {
                    query: addressSearchText,
                    country: isoCountryCode,
                    take: 100,
                };

                if (countryCode === 'US' && useGeoLocation) {
                    const { lat, long } = this.location;
                    if (lat && long) {
                        params.location = `${lat},${long}`;
                    }
                }
                QasClient.qasGet({}, 'search', params, timeoutInSecs).then((res) => {
                    this.setState({
                        autoCompleteResult: res.data,
                    });
                }).catch((ex) => {
                    this.resetAutoSearch();
                    this.handleQASAddressFailed();
                    mbpLogger.logError({
                        function: 'searchAddress',
                        appName: process.env.npm_package_name,
                        module: 'mbp-checkout',
                        message: `Get QAS Address failed ${cartId}`,
                        jsError: ex,
                        orderId: cartId,
                    });
                    console.log('QAS error:', ex);
                    console.log('QAS error object:', JSON.stringify(ex));
                    console.log('QAS error - response:', ex?.response);
                    console.log('QAS params:', params);
                });
            }
        } else {
            this.resetAutoSearch();
        }
    }

    handleClickAway = () => {
        const { onBlurHandler } = this.props;
        onBlurHandler();
    }

    render() {
        const {
            searchId,
            children,
            classes,
            isFocus,
        } = this.props;
        return (
            <div id={`auto_${searchId}`}>
                <div>
                    {children}
                    {this.showSuggestion()
                        && (
                            <ClickAwayListener onClickAway={this.handleClickAway}>
                                <div className={classes.wrapSuggestion}>
                                    <Paper className={classes.autoSuggestion}>
                                        <MenuList className={classes.menuListWrapper} autoFocusItem={isFocus}>
                                            {this.getSuggestions()}
                                        </MenuList>
                                    </Paper>
                                </div>
                            </ClickAwayListener>
                        )}
                </div>
            </div>
        );
    }
}

AddressVerificationSearch.defaultProps = {
    searchTextFocus: false,
    onBlurHandler: () => { },
    useGeoLocation: false,
    isFocus: false,
    countryCode: 'US',
    state: null,
    track: () => { },
};

AddressVerificationSearch.propTypes = {
    callEmitClickstreamCheckoutEvent: func.isRequired,
    callFlagOnQasFailed: func.isRequired,
    children: node.isRequired,
    classes: object.isRequired,
    countryCode: string,
    featureFlags: object.isRequired,
    getPreFillAddressDetails: func.isRequired,
    isFocus: bool,
    onBlurHandler: func,
    searchText: string.isRequired,
    searchTextFocus: bool,
    searchId: string.isRequired,
    track: func,
    useGeoLocation: bool,
    cartId: string.isRequired,
    state: string,
    zipCode: string.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    callEmitClickstreamCheckoutEvent: bindActionCreators(emitClickstreamCheckoutEvent, dispatch),
    callFlagOnQasFailed: bindActionCreators(flagOnQasFailed, dispatch),
    track: bindActionCreators(trackEvent, dispatch),
});
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
    cartId: getOrderId(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddressVerificationSearch));
